import request from '@/utils/request'

//课程列表
export function appCourseList(data) {
	return request({
		url: '/app/course/appCourseList',
		method: 'get',
		params: data
	})
}

//课程学习-tree列表
export function appCourseTree(data) {
	return request({
		url: '/app/course/appCourseTree',
		method: 'get',
		params: data
	})
}
//我的课程
export function listCourse(data) {
	return request({
		url: '/user/course/listCourse',
		method: 'get',
		params: data
	})
}

//报名
export function sign(data) {
	return request({
		url: '/user/course/sign',
		method: 'post',
		data
	})
}

//取消报名
export function unSign(data) {
	return request({
		url: '/user/course/unSign',
		method: 'post',
		data
	})
}
//文件下载
export function downLoadFile(data) {
	return request({
		url: '/api/course/downLoadFile',
		method: 'get',
		params: data
	})
}
//课程推荐
export function courseRecommend(data) {
	return request({
		url: '/api/course/courseRecommend',
		method: 'get',
		params: data
	})
}
//根据课程id查询章节树不带附件
export function getCourseTree(data) {
	return request({
		url: '/api/course/getCourseTreeManage',
		method: 'get',
		params: data
	})
}

//根据课程附件id查询互动试题
export function getListByFileId(data) {
	return request({
		url: '/courseAsk/getListByFileId',
		method: 'get',
		params: data
	})
}
//根据试题id查询试题详情
export function getAskTopicById(data) {
	return request({
		url: '/courseAsk/getAskTopicById',
		method: 'get',
		params: data
	})
}

//添加互动答案
export function addAskTopicAnswer(data) {
	return request({
		url: '/courseAskAnswer/addAskTopicAnswer',
		method: 'post',
		data
	})
}
//查询该用户互动答题情况
export function courseAskAnswers(data) {
	return request({
		url: '/courseAskAnswer/getMy',
		method: 'get',
		params: data
	})
}
//共享专区课程列表
export function shareList(data) {
	return request({
		url: '/api/share/shareList',
		method: 'get',
		params: data
	})
}
//平台搜索
export function platformSearch(data) {
	return request({
		url: '/api/student/platformSearch',
		method: 'get',
		params: data
	})
}

//查询课程明细
export function selectCourseDetail(data) {
	return request({
		url: '/courseDetail/tMoocCourseDetailDO/selectCourseDetail',
		method: 'get',
		params: data
	})
}
//根据id查询课程明细
export function getCourseDetailById(data) {
	return request({
		url: '/courseDetail/tMoocCourseDetailDO/getById',
		method: 'get',
		params: data
	})
}

//查询水印
export function watermarkList(data) {
	return request({
		url: '/watermark/tMoocCourseWatermarkDO/list',
		method: 'get',
		params: data
	})
}
//根据课程id查询团队人员介绍
export function getTeamIntroductionByCourseId(data) {
	return request({
		url: '/api/course/getTeamIntroductionByCourseId',
		method: 'get',
		params: data
	})
}

